import { render, staticRenderFns } from "./DragAndDropPreview.vue?vue&type=template&id=66782382"
import script from "./DragAndDropPreview.vue?vue&type=script&lang=ts"
export * from "./DragAndDropPreview.vue?vue&type=script&lang=ts"
import style0 from "./DragAndDropPreview.vue?vue&type=style&index=0&id=66782382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports